import type { FetchBlogsQuery } from '@eliadmin/core/src/api/blogs/blogs-api';

/** Two rows of the desktop grid (Figma 60343:25290); every „Zobraziť viac článkov“ adds as many. */
export const POSTS_PER_PAGE = 6;

/** Articles of a list: from these categories and/or without one article (featured, the open one). */
export type PostFilter = { categoryIds?: number[]; excludeId?: number };

/** Newest first, as the grid and „Podobné články“ show them (server and client use the same query). */
export function postsQuery(
  { categoryIds, excludeId }: PostFilter,
  { page = 1, results = POSTS_PER_PAGE }: { page?: number; results?: number } = {},
): FetchBlogsQuery {
  const where: FetchBlogsQuery['where'] = {
    ...(categoryIds?.length ? { categories: { in: categoryIds } } : {}),
    ...(excludeId ? { id: { not_in: [excludeId] } } : {}),
  };

  return {
    page,
    results,
    orderBy: 'created_at',
    order: 'desc',
    where: Object.keys(where).length ? where : undefined,
  };
}

/** The featured article is the most read one (Figma badge „Najčítanejšie“). */
export const MOST_READ_QUERY: FetchBlogsQuery = { results: 1, orderBy: 'views', order: 'desc' };
